import { FilePreviewProps } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/Types'
import Styles from './ArticlePreview.module.scss'
import { PreviewUnavailable } from './PreviewUnavailable'
import { EmptyDoc } from 'screens/blaze/Home/components/Catalogue/components/FilePreview/EmptyDoc'
import cx from 'classnames'
import { useRef } from 'react'

export const ArticlePreview = ({ file, className, emptyClassName }: FilePreviewProps) => {
  const imageRef = useRef<HTMLImageElement>(null)
  const { title, preview_url } = file

  const aspectRatio = (imageRef.current?.naturalWidth || 0) / (imageRef.current?.naturalHeight || 1) 

  if (file.is_blank && !preview_url) {
    return <EmptyDoc />
  }

  if (!preview_url) {
    return <PreviewUnavailable className={emptyClassName} />
  }

  return (
    <div className={cx(Styles.preview, className)}>
      <img
        src={file.preview_url}
        alt={title}
        className={cx(Styles.image, {[Styles.squareAspectRatio]: aspectRatio === 1})}
        ref={imageRef}
      />
    </div>
  )
}
